import { useDialogStore } from "src/stores/dialog-store";

export const updateDialogState = ({
  dialog = "",
  val = false,
  parentDialog = "",
  properties = null,
  refresh = false,
}) => {
  const dialogStore = useDialogStore();
  if (dialog) {
    dialogStore.updateDialogState({
      dialog,
      val: !!val,
      parentDialog,
    });

    if (properties)
      dialogStore.setDialogProperties({
        dialog,
        properties,
        refresh,
      });
  }
};

export const deleteDialogProperties = (dialog = "") => {
  const dialogStore = useDialogStore();
  if (dialog) dialogStore.deleteDialogProperties(dialog);
};
